module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-about-orthodontics"
  }, [(_vm.loading) ? _c('Loader') : _vm._e(), _c('Header'), (_vm.props) ? _c('div', {
    staticClass: "inner-page"
  }, [_c('div', {
    staticClass: "subnav"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/about-orthodontics"
    }
  }, [_vm._v("About Orthodontics")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/life-with-braces"
    }
  }, [_vm._v("Life with Braces")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/brushing-and-flossing"
    }
  }, [_vm._v("Brushing and Flossing")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/for-all-ages"
    }
  }, [_vm._v("For All Ages")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/early-prevention"
    }
  }, [_vm._v("Early Prevention")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/types-of-appliances"
    }
  }, [_vm._v("Types of Appliances")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/palatal-expander"
    }
  }, [_vm._v("Palatal Expander")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/orthodontic-retention"
    }
  }, [_vm._v("Orthodontic Retention")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/emergency-care"
    }
  }, [_vm._v("Emergency Care")])], 1)])]), _c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "left-area"
  }, [_c('H1', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.title.rendered)
    }
  }), _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  })], 1), _c('div', {
    staticClass: "featured-img"
  }, [(_vm.props.better_featured_image) ? _c('figure', [_c('img', {
    attrs: {
      "src": _vm.props.better_featured_image.source_url
    }
  })]) : _vm._e()])])])]) : _vm._e(), _c('Footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ba434bf2","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/about-orthodontics/about-orthodontics.pug
// module id = 1301
// module chunks = 1